const CPDischarge = "Pending discharge form";
const CPAssignment = "Pending assignment"; //if no team member is assigned.
const CPProblem = "Pending problem assignment";
const CPQues = "Pending questionnaire";
const CPTeam = "Pending team assignment";
const CPShare = "Pending share with provider";
const CPSignOff = "Pending for provider approval";
const CPComplete = "Pending careplan complete";
const Recurring = "Pending for recurring";

///For RPM Program Changes
const CPDeviceAssign = "Pending device assignment";

const CPStage = [
  CPDischarge,
  CPAssignment,
  CPProblem,

  ///For RPM Program Changes
  CPDeviceAssign,
  CPTeam,
  CPQues,
  CPShare,
  CPSignOff,
  CPComplete,
  Recurring,
];

export default {
  CPDischarge,
  CPAssignment,
  CPProblem,

  ///For RPM Program Changes
  CPDeviceAssign,

  CPQues,
  CPTeam,
  CPShare,
  CPSignOff,
  CPComplete,
  Recurring,
  CPStage,
};
